export const regionCodes = [
    { value: '', label: '-Seleziona codice regione-' },
    { value: '010', label: '010 (Piemonte)' },
    { value: '020', label: '020 (Valle d\'Aosta)' },
    { value: '030', label: '030 (Lombardia)' },
    { value: '041', label: '041 (P.A. di Bolzano)' },
    { value: '042', label: '042 (P.A. di Trento)' },
    { value: '050', label: '050 (Veneto)' },
    { value: '060', label: '060 (Friuli Venezia Giulia)' },
    { value: '070', label: '070 (Liguria)' },
    { value: '080', label: '080 (Emilia Romagna)' },
    { value: '090', label: '090 (Toscana)' },
    { value: '100', label: '100 (Umbria)' },
    { value: '110', label: '110 (Marche)' },
    { value: '120', label: '120 (Lazio)' },
    { value: '130', label: '130 (Abruzzo)' },
    { value: '140', label: '140 (Molise)' },
    { value: '150', label: '150 (Campania)' },
    { value: '160', label: '160 (Puglia)' },
    { value: '170', label: '170 (Basilicata)' },
    { value: '180', label: '180 (Calabria)' },
    { value: '190', label: '190 (Sicilia)' },
    { value: '200', label: '200 (Sardegna)' },
];


export class Order {

    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.email = data.email;
        this.pec = data.pec;
        this.phone = data.phone;
        this.province = data.province;
        this.export_infocamere = data.export_infocamere;
        this.code_infocamere = data.code_infocamere;
        this.fiscal_code = data.fiscal_code;
        this.fiscal_domicile_province = data.fiscal_domicile_province;
        this.fiscal_domicile_city = data.fiscal_domicile_city;
        this.fiscal_domicile_address = data.fiscal_domicile_address;
        this.fiscal_domicile_postal_code = data.fiscal_domicile_postal_code;
        this.opening_hours = data.opening_hours;
        this.holidays_opening_hours = data.holidays_opening_hours;
        this.website = data.website;
        this.region_code = data.region_code;
    }
}

export class OrderEssential {

    constructor(data) {
        this.id = data.id;
        this.name = data.name;
    }
}
